<template>
    <table-base :filter="filter" :headers="headers" :api-data="apiData" :sorting="sorting" :items-field="itemsField" :edit-page-name="editPageName" :api-method="apiMethod" :claim-name="claimName" :form-title="formTitle" :excel-title="excelTitle" :has-edit-page="hasEditPage" :table-form="containerFileForm" :refresh-key="refreshKey" :show-expand="false" />
</template>

<script>
    export default {
        props: [
            'filter',
            'refreshKey'
        ],
        components: {
            tableBase: () => import('../components/TableBase'),
        },
        data() {
            return {
                containerFileForm: () => import('../forms/ContainerFileForm'),
                headers: [
                    { text: 'Container', value: 'containerId', table: 'containers', form: () => import('../forms/ContainerForm') },
                    { text: 'File', value: 'fileId', table: 'files', form: () => import('../forms/FileForm') },
                    { text: '', value: 'action' }
                ],
                apiData: {
                    containers: [],
                    files: [],
                    items: []
                },
                sorting: [
                    { column: "containerId", direction: "ascending" },
                    { column: "fileId", direction: "ascending" },
                ],
                itemsField: 'containerFiles',
                editPageName: 'containerFile',
                apiMethod: 'ContainerFiles',
                claimName: 'ContainerFiles',
                formTitle: 'Container File',
                excelTitle: 'Container Files',
                hasEditPage: false,
            }
        },
    };
</script>
